import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const schema = () => ({
  units: Yup.array().of(
    Yup.object({
      name: Yup.string().required(),
      uid: Yup.string().required(),
      isActive: Yup.boolean().required(),
      isTemporary: Yup.boolean(),
    }),
  ),
  extraUnits: Yup.number(),
});

export type UnitListSchemaType = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof schema>>
>;
